import imgmonard91 from "./monard-9.webp";
import imgmonard92 from "./monard-9 (2).webp";
import imgmonard93 from "./monard-9 (3).webp";
import imgmonard94 from "./monard-9 (4).webp";
import imgmonard95 from "./monard-9 (5).webp";

const imgmonard9 = [
    imgmonard91,
    imgmonard92,
    imgmonard93,
    imgmonard94,
    imgmonard95,
]

export default imgmonard9